import {createCookie} from "./create-cookie.ts";
import {CookieCategory} from "./types.ts";

/**
 * Erases the cookie with the given name.
 *
 * @param name - The name of the cookie to erase.
 * @param [domain] - The domain for which the cookie is valid.
 */
export function eraseCookie(name: string, domain?: string): void {
    createCookie(name, CookieCategory.StrictlyNecessary, "", -1, domain);
}
